import React, { forwardRef } from 'react';
import { Checkbox, Heading, Text } from '@chakra-ui/react';
import type { UseFormRegisterReturn } from 'react-hook-form';

interface Props extends UseFormRegisterReturn {
    translate: (key: string) => string;
}

const InvoiceAutoPaySetUp = forwardRef<HTMLInputElement, Props>(function InvoiceAutoPaySetUp(
    { translate, ...rest },
    ref
) {
    return (
        <>
            <Heading as="h3" size="lg" marginBottom={0}>
                {translate('setUpAutoPay')}
            </Heading>
            <Checkbox {...rest} ref={ref}>
                {translate('setUpAutoPayConfirmation')}
            </Checkbox>
            <Text fontSize="xs">*{translate('setUpAutoPayDisclaimer')}</Text>
        </>
    );
});

export default InvoiceAutoPaySetUp;
